import {
  ArrowLeftCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { useRouter } from "next/router";
import { useState } from "react";
import { Vehicle } from "../graphql/generated/graphql";
import { TIER_KEYS } from "../utils/constants";
import { classNames } from "../utils/formatters";
import BumpVehicleButton from "./BumpVehicleButton";
import DeleteVehicleButton from "./DeleteVehicleButton";
import DeleteVehicleModal from "./DeleteVehicleModal";
import EditVehicleButton from "./EditVehicleButton";
import PromoteVehicleButton from "./PromoteVehicleButton";
import RenewVehicleButton from "./RenewVehicleButton";

export default function VehicleDetailNav({
  data,
  isCurrentUser,
  title,
  expired,
}: {
  data: Vehicle;
  isCurrentUser?: boolean;
  title?: string;
  expired?: boolean;
}) {
  const router = useRouter();

  const [deleteModalState, setDeleteModalState] =
    useState<TVehicleActionModalState>({
      open: false,
      data: null,
    });

  const toggleDeleteModal = (data?: Vehicle) => {
    setDeleteModalState({
      open: !deleteModalState.open,
      data,
    });
  };

  return (
    <div
      className={classNames(
        isCurrentUser ? "bg-gray-100 mb-3" : "bg-white my-3"
      )}
    >
      <div className="mx-auto max-w-7xl py-3 px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <ol role="list" className="flex items-center space-x-2">
              <li>
                <div className="flex items-center">
                  <button
                    onClick={() => router.back()}
                    className={classNames(
                      "mr-2 text-sm font-medium text-gray-900 hover:text-orange-500"
                    )}
                  >
                    <ArrowLeftCircleIcon className="h-7 w-7" />
                  </button>
                  <svg
                    width={16}
                    height={20}
                    viewBox="0 0 16 20"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    className={classNames(
                      "w-4 h-5",
                      isCurrentUser ? "text-gray-900" : "text-gray-300"
                    )}
                  >
                    <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                  </svg>
                </div>
              </li>
              <li className="text-sm capitalize">
                <a
                  // href={product.href}
                  href=""
                  aria-current="page"
                  className="font-medium text-gray-500 hover:text-gray-600"
                >
                  {title}
                </a>
              </li>
            </ol>
          </div>
          <div className="flex items-center space-x-2">
            {expired ? (
              <span className="text-gray-600 text-sm capitalize flex items-center gap-x-1">
                <ExclamationTriangleIcon className="text-red-500 h-5 w-5" />
                Anuncio expirado
              </span>
            ) : null}
            {isCurrentUser &&
            data.listingTier !== TIER_KEYS.FREE &&
            data.listingTier !== TIER_KEYS.COLLECTION &&
            !expired ? (
              <BumpVehicleButton data={data} />
            ) : null}

            {isCurrentUser &&
            data.listingTier === TIER_KEYS.FREE &&
            !expired ? (
              <PromoteVehicleButton data={data} />
            ) : null}

            {isCurrentUser && !expired ? (
              <EditVehicleButton data={data} />
            ) : null}
            {isCurrentUser && expired ? (
              <RenewVehicleButton data={data} />
            ) : null}
            {isCurrentUser ? (
              <DeleteVehicleButton onClick={toggleDeleteModal} data={data} />
            ) : null}
          </div>
        </div>
      </div>
      {isCurrentUser ? (
        <DeleteVehicleModal
          modalState={deleteModalState}
          setModalState={toggleDeleteModal}
        />
      ) : null}
    </div>
  );
}
